exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slideShow {\n  width: 450px;\n  height: 450px;\n  position: relative;\n  overflow: hidden;\n  margin: 0 auto;\n  text-align: center; }\n  .slideShow button {\n    opacity: 0;\n    -webkit-transition: opacity ease-in-out 200ms;\n    transition: opacity ease-in-out 200ms;\n    position: absolute;\n    top: 150px;\n    background-color: white;\n    cursor: pointer;\n    border: none;\n    color: #ad0e68;\n    font-weight: bold;\n    font-size: 1.5em; }\n  .slideShow button#next {\n      right: 0; }\n  .slideShow button#previous {\n      left: 0; }\n  .slideShow:hover button {\n    opacity: 1.0; }\n  .slideShow ul {\n    list-style: none;\n    padding: 0;\n    position: relative;\n    height: 450px;\n    text-align: center;\n    margin: 0 auto;\n    overflow: hidden;\n    -webkit-transition: left 400ms ease-in-out;\n    transition: left 400ms ease-in-out; }\n  .slideShow ul li {\n      position: relative;\n      float: left; }\n  .slideShow ul li img {\n        max-width: 450px;\n        max-height: 450px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/app/bilder/bilder.component.scss
// module id = ../../../../../src/app/bilder/bilder.component.scss
// module chunks = main